import { useCallback, useState } from "react";

import { collection, getDocs, query, where } from "firebase/firestore";

import { db } from "../firebase";

import { guardarCache, leerCache } from "../utils/cacheManager";

function useTiendaData(turnoActual) {
  const [productos, setProductos] = useState([]);

  const [catalogoCompleto, setCatalogoCompleto] = useState([]);

  const [banners, setBanners] = useState([]);

  const [especiales, setEspeciales] = useState([]);

  const [promocionesActivas, setPromocionesActivas] = useState([]);

  const CACHE_PRODUCTOS_KEY = "mitico_cache_productos";

  const CACHE_BANNERS_KEY = "mitico_cache_banners";

  const CACHE_ESPECIALES_KEY = "mitico_cache_especiales";

  const CACHE_PROMOS_KEY = "mitico_cache_promos";

  const cargarTiendaMítica = useCallback(async () => {
    try {
      // =========================
      // CACHE
      // =========================

      const productosCacheados = leerCache(CACHE_PRODUCTOS_KEY);

      const bannersCacheados = leerCache(CACHE_BANNERS_KEY);

      const especialesCacheados = leerCache(CACHE_ESPECIALES_KEY);

      const promosCacheadas = leerCache(CACHE_PROMOS_KEY);

      if (productosCacheados && Array.isArray(productosCacheados)) {
        setCatalogoCompleto(productosCacheados);

        const ahoraCache = new Date();

        const menuCacheFiltrado = productosCacheados.filter((prod) => {
          const coincideTurno =
            prod.turno === turnoActual || prod.turno === "ambos";

          const estaBloqueadoPorTiempo =
            prod.bloqueadoHasta && new Date(prod.bloqueadoHasta) > ahoraCache;

          const estaDisponible =
            prod.disponible !== false && !estaBloqueadoPorTiempo;

          return coincideTurno && estaDisponible;
        });

        setProductos(menuCacheFiltrado);
      }

      if (bannersCacheados) {
        setBanners(bannersCacheados);
      }

      if (especialesCacheados) {
        setEspeciales(especialesCacheados);
      }

      if (promosCacheadas) {
        setPromocionesActivas(promosCacheadas);
      }

      // =========================
      // FIREBASE
      // =========================

      const ahora = new Date();

      const [productosSnap, bannersSnap, promosSnap, especialesSnap] =
        await Promise.all([
          getDocs(
            query(
              collection(db, "productos"),
              where("disponible", "!=", false),
              where("turno", "in", [turnoActual, "ambos"]),
            ),
          ),

          getDocs(collection(db, "marketing")),

          getDocs(collection(db, "promociones")),

          getDocs(collection(db, "especiales")),
        ]);

      const listaCompleta = productosSnap.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }));
      console.log("TURNO ACTUAL:", turnoActual);
      console.log("PRODUCTOS FIREBASE:", listaCompleta);
      console.log(
        "TURNOS RECIBIDOS:",
        listaCompleta.map((p) => ({
          nombre: p.nombre,
          turno: p.turno,
          disponible: p.disponible,
          bloqueadoHasta: p.bloqueadoHasta,
        })),
      );
      setCatalogoCompleto(listaCompleta);

      guardarCache(CACHE_PRODUCTOS_KEY, listaCompleta);
      const menuFiltrado = listaCompleta.filter((prod) => {
        const coincideTurno =
          prod.turno === turnoActual || prod.turno === "ambos";

        const estaBloqueadoPorTiempo =
          prod.bloqueadoHasta && new Date(prod.bloqueadoHasta) > ahora;

        const estaDisponible =
          prod.disponible !== false && !estaBloqueadoPorTiempo;

        return coincideTurno && estaDisponible;
      });

      setProductos(menuFiltrado);

      setBanners(
        bannersSnap.docs.map((doc) => ({
          id: doc.id,
          ...doc.data(),
        })),
      );

      guardarCache(
        CACHE_BANNERS_KEY,
        bannersSnap.docs.map((doc) => ({
          id: doc.id,
          ...doc.data(),
        })),
      );

      const listaPromos = promosSnap.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }));

      const promosActivas = listaPromos.filter((p) => p.activa !== false);

      setPromocionesActivas(promosActivas);

      guardarCache(CACHE_PROMOS_KEY, promosActivas);

      let listaEspeciales = especialesSnap.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }));

      listaEspeciales = listaEspeciales.filter((esp) => {
        if (!esp.promoId) return true;

        const promo = promosActivas.find((p) => p.id === esp.promoId);

        if (!promo) return false;

        let prodId =
          promo.tipo === "regalo" ? promo.detonanteId : promo.productoId;

        if (!prodId) return true;

        return menuFiltrado.some((p) => p.id === prodId);
      });

      setEspeciales(listaEspeciales);
      guardarCache(CACHE_ESPECIALES_KEY, listaEspeciales);
    } catch (error) {
      console.error("Error cargando tienda:", error);
    }
  }, [turnoActual]);

  return {
    productos,
    catalogoCompleto,
    banners,
    especiales,
    promocionesActivas,
    cargarTiendaMítica,
  };
}

export default useTiendaData;
